var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDone(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_398_10262)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7 0C3.14039 0 0 3.14039 0 7C0 10.8596 3.14039 14 7 14C10.8596 14 14 10.8596 14 7C14 3.14039 10.8596 0 7 0ZM10.912 5.15791L6.4384 9.59626C6.17524 9.85942 5.75412 9.87689 5.47349 9.61374L3.1051 7.45607C2.82447 7.19291 2.80699 6.75432 3.05233 6.47369C3.31548 6.19306 3.75408 6.17558 4.03471 6.43874L5.91174 8.15816L9.91184 4.15806C10.1925 3.87743 10.6311 3.87743 10.9117 4.15806C11.193 4.43869 11.193 4.87728 10.912 5.15791Z",
    fill: "#4E5574"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_398_10262"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 14,
    height: 14,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDone);
export default __webpack_public_path__ + "static/media/done.18051344c39725f934df75daff0c510c.svg";
export { ForwardRef as ReactComponent };